import { IMAGES } from '../constants/image';

export type MessageResponsePayload = {
  type?: string;
  response_code?: number;
  message_type?: string;
  message_code?: string;
  message_short?: string;
  message_long?: string;
};

export type ExtractedMessageResponse = {
  status: number;
  message: string;
  messageType?: string;
  messageCode?: string;
};

export const extractMessageResponse = (
  apiData: any,
  fallbackMessage: string,
  fallbackStatus = 500,
): ExtractedMessageResponse => {
  const messageResponse: MessageResponsePayload | undefined =
    apiData?.message_response ?? apiData?.messageResponse;

  const status = messageResponse?.response_code ?? apiData?.response_code ?? fallbackStatus;
  const message =
    messageResponse?.message_short ||
    apiData?.message_short ||
    apiData?.message ||
    apiData?.error ||
    fallbackMessage;
  const messageType = messageResponse?.message_type ?? apiData?.message_type;
  const messageCode = messageResponse?.message_code ?? apiData?.message_code;

  return {
    status,
    message: typeof message === 'string' ? message : String(message),
    messageType,
    messageCode,
  };
};

export const getMessagePopupConfig = (
  messageType?: string,
  messageCode?: string,
  status?: number,
) => {
  const normalizedType = (messageType || '').toUpperCase();
  const normalizedCode = (messageCode || '').toUpperCase();

  if (normalizedType === 'S' || normalizedCode.startsWith('S')) {
    return {
      title: 'Success!',
      btnClass: 'btn-success',
      accentClass: 'gp-accent-success',
      icon: IMAGES.ICONS.SUCCESS,
      iconAlt: 'Success',
    };
  }

  if (normalizedType === 'E' || normalizedCode.startsWith('E')) {
    return {
      title: 'Error!',
      btnClass: 'btn-danger',
      accentClass: 'gp-accent-danger',
      icon: IMAGES.ICONS.ERROR,
      iconAlt: 'Error',
    };
  }

  if (status === 403) {
    return {
      title: 'Unauthorized!',
      btnClass: 'btn-warning',
      accentClass: 'gp-accent-warning',
      icon: IMAGES.ICONS.UNAUTHORIZED,
      iconAlt: 'Unauthorized',
    };
  }

  if (status === 404) {
    return {
      title: 'Not Found!',
      btnClass: 'btn-primary',
      accentClass: 'gp-accent-info',
      icon: IMAGES.ICONS.NOT_FOUND,
      iconAlt: 'Not found',
    };
  }

  if (status === 500) {
    return {
      title: 'Server Error!',
      btnClass: 'btn-secondary',
      accentClass: 'gp-accent-secondary',
      icon: IMAGES.ICONS.SERVER_ERROR,
      iconAlt: 'Server error',
    };
  }

  return {
    title: 'Notice',
    btnClass: 'btn-primary',
    accentClass: 'gp-accent-info',
    icon: IMAGES.ICONS.WARNING,
    iconAlt: 'Warning',
  };
};
